
export enum DoaForecastList {
  available = 'availability-list',
  shortage = 'shortage-list',
  jobs = 'jobs-required'
}

export enum DoaForecastTableColor {
  green = 'green',
  red = 'red'
}

export enum StatusType {
  available = 'available',
  contacted = 'contacted'
}
